import compact from "lodash/compact";

const getContactName = <C extends { first_name?: string | null; last_name?: string | null }>(contact: C): string => {
  return compact([contact.first_name, contact.last_name]).join(" ");
};

export default getContactName;
